import { render, staticRenderFns } from "./marketing-plan-overview-widget.vue?vue&type=template&id=2950d2e2&"
import script from "./marketing-plan-overview-widget.vue?vue&type=script&lang=js&"
export * from "./marketing-plan-overview-widget.vue?vue&type=script&lang=js&"
import style0 from "./marketing-plan-overview-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports